import { stockActions, service } from '..';

const endPoint = 'stock';

export const stockService = {
  getStocks : materialsWithStockFilter => service( endPoint )
    .post( {materials: materialsWithStockFilter.products, hasStockFilter: materialsWithStockFilter.hasStockFilter}, 'batch' )
    .then( data => !data.data ? { type: stockActions.FAILED, products: materialsWithStockFilter.products }: {type: stockActions.RETRIEVED , result: data.data, products: materialsWithStockFilter.products })
}